"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Title = exports.Pane = exports.Header = exports.Footer = exports.FadeInOverlay = exports.CloseIcon = exports.Body = exports.AdvancedPane = exports.AdvancedBody = void 0;
var _polished = require("polished");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = _interopRequireDefault(require("../../../styles/colors"));
var _ActionIcon = _interopRequireDefault(require("../../../forms/ActionIcon"));
var _Text = _interopRequireDefault(require("../../../text/Text"));
var _zIndex = _interopRequireDefault(require("../../../styles/zIndex"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var paneWidth = '21.5rem';
var slideIn = (0, _styledComponents.keyframes)(["from{transform:translate3d(300px,0,0);}to{transform:translate3d(0,0,0);}"]);
var fadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
var FadeInOverlay = exports.FadeInOverlay = _styledComponents.default.div.withConfig({
  displayName: "styled__FadeInOverlay",
  componentId: "sc-680i34-0"
})(["animation:", " 200ms forwards ease-in;position:fixed;top:0;left:0;width:100%;height:100%;z-index:", ";background:", ";"], fadeIn, function (_ref) {
  var $overModal = _ref.$overModal;
  return $overModal ? _zIndex.default.modal + 1 : _zIndex.default.drawer;
}, (0, _polished.rgba)(_colors.default.grey90, 0.8));
var Wrapper = exports.Wrapper = _styledComponents.default.div.withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-680i34-1"
})(["animation:", " 200ms forwards ease-out;position:fixed;top:0;right:0;display:flex;height:100%;box-shadow:0 -0.5rem 1rem 0 ", ";z-index:", ";background-color:", ";&:focus{outline:none;}"], slideIn, (0, _polished.rgba)(_colors.default.black, 0.25), function (_ref2) {
  var $overModal = _ref2.$overModal;
  return $overModal ? _zIndex.default.modal + 1 : _zIndex.default.drawer;
}, _colors.default.white);
var Pane = exports.Pane = _styledComponents.default.div.withConfig({
  displayName: "styled__Pane",
  componentId: "sc-680i34-2"
})(["width:", ";display:flex;flex-direction:column;justify-content:space-between;background-color:", ";"], paneWidth, _colors.default.grey10);
var Title = exports.Title = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "styled__Title",
  componentId: "sc-680i34-3"
})(["margin-bottom:1rem;"]);
var Header = exports.Header = _styledComponents.default.div.withConfig({
  displayName: "styled__Header",
  componentId: "sc-680i34-4"
})(["display:flex;flex-direction:column;padding:1.5rem 1rem;background-color:", ";box-shadow:inset 0 -1px 0 0 ", ";> ", ":only-child{margin-bottom:0;}"], _colors.default.white, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.divider.light;
}, Title);
var Body = exports.Body = _styledComponents.default.div.withConfig({
  displayName: "styled__Body",
  componentId: "sc-680i34-5"
})(["overflow-y:auto;overflow-x:hidden;padding:1rem;flex:auto;background-color:", ";"], _colors.default.white);
var Footer = exports.Footer = _styledComponents.default.div.withConfig({
  displayName: "styled__Footer",
  componentId: "sc-680i34-6"
})(["display:flex;flex-direction:row;justify-content:flex-start;padding:1rem;background-color:", ";box-shadow:0 -1px 0 0 ", ";"], _colors.default.white, _colors.default.grey20);
var AdvancedPane = exports.AdvancedPane = _styledComponents.default.div.withConfig({
  displayName: "styled__AdvancedPane",
  componentId: "sc-680i34-7"
})(["background:", ";border-left:", " 1px solid;overflow-y:auto;overflow-x:hidden;width:", ";animation:", " 200ms forwards ease-out;"], _colors.default.white, _colors.default.grey20, function (p) {
  return p.$width ? "".concat(p.$width, "rem") : '30rem';
}, fadeIn);
var AdvancedBody = exports.AdvancedBody = _styledComponents.default.div.withConfig({
  displayName: "styled__AdvancedBody",
  componentId: "sc-680i34-8"
})(["padding:1.5rem 1rem;height:100%;display:flex;flex:none;flex-direction:column;justify-content:space-between;"]);
var CloseIcon = exports.CloseIcon = (0, _styledComponents.default)(_ActionIcon.default).withConfig({
  displayName: "styled__CloseIcon",
  componentId: "sc-680i34-9"
})(["position:absolute;right:1.5rem;top:1.5rem;"]);